<template>
<div class="row middle-xs center-xs">
  <v-alert
    v-if="!checkSuccess()"
    :value="true"
    type="error"
  >
    {{ $vuetify.lang.t('$vuetify.wechat.error') }}
  </v-alert>

  <v-alert
    v-if="!cardMatches()"
    :value="true"
    type="error"
  >
    {{ $vuetify.lang.t('$vuetify.wechat.mismatch') }} <br>
    '{{$route.query.mchOrderNo}}' !== '{{billingInfo.transactionId}}'
  </v-alert>
  <v-progress-circular
    v-else
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="mt-3 mb-3"
  ></v-progress-circular>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      status: 0
    }
  },

  computed: {
    ...mapGetters({
      billingInfo: 'getBillingInfo',
    })
  },

  methods: {
    checkSuccess() {
      return this.status === 2 || this.status === 3
    },
    cardMatches() {
      return this.billingInfo.transactionId && this.$route.query.mchOrderNo == this.billingInfo.transactionId
    }
  },

  mounted() {
    this.status = parseInt(this.$route.query.status, 10)

    if (this.checkSuccess() && this.cardMatches()) {
      this.$router.push({path: `/Confirmation/${this.$route.params.storeId}`})
    }
  }
};
</script>

<style scoped>
  .row {
    height: 100vh;
    width: 100vw;
  }
</style>
